import { Route, Routes } from 'react-router-dom';

import { CommunicationNewsletter } from '../../pages/Communications/Newsletter';
import { CommunicationStatus } from '../../pages/Communications/Status';

const CommunicationRoutes = () => {
  return (
    <Routes>
      <Route path="/:causeId/status" element={<CommunicationStatus />} />

      <Route path="/newsletters/:newsletterId" element={<CommunicationNewsletter />} />
    </Routes>
  );
};

export { CommunicationRoutes };
